// Shared Escape-to-clear behavior for search/filter text inputs. Several of
// these inputs live inside a ModalShell, whose Escape-to-close listener is
// attached at the document level (see useEscapeToClose.ts) — stopping
// propagation here means Escape clears the text first, and only closes the
// modal on a second press once the field is already empty.
import type { KeyboardEvent } from "react";

export function clearOnEscape(value: string, setValue: (v: string) => void) {
  return (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Escape" && value) {
      e.stopPropagation();
      setValue("");
    }
  };
}
